var buddhaSrcset = window.buddhaSrcset || [] ;

function buddhaSrcset(){
    this.images = [];
    this.width = window.innerWidth;
    this.getImages();
    this.setImages();
    this.triggerEvents();
    
}

buddhaSrcset.prototype.triggerEvents = function(){
    var t =this;
    window.addEventListener("resize",function(){ t.windowResize(); });
}

buddhaSrcset.prototype.getImages = function(){
    var pictures = document.querySelectorAll('figure img');
    var images = [];
    for(var i = 0; i < pictures.length; i++) {
        if(pictures[i].hasAttribute('srcset')){
            var srcset = pictures[i].getAttribute('srcset').split(", ");
            for(var j = 0; j < srcset.length; j++){
                srcset[j] = srcset[j].split(" ");
                if(typeof images[i] == 'undefined'){
                    images[i] = [];
                }
                images[i][srcset[j][1]]= srcset[j][0];
            }
            pictures[i].removeAttribute('srcset');
            pictures[i].removeAttribute('sizes');
            pictures[i].removeAttribute('data-srcset');
            pictures[i].removeAttribute('data-sizes');
        }
        if(pictures[i].hasAttribute('data-srcset')){
            var srcset = pictures[i].getAttribute('data-srcset').split(", ");
            for(var j = 0; j < srcset.length; j++){
                srcset[j] = srcset[j].split(" ");
                if(typeof images[i] == 'undefined'){
                    images[i] = [];
                }
                images[i][srcset[j][1]]= srcset[j][0];
            }
            pictures[i].removeAttribute('srcset');
            pictures[i].removeAttribute('sizes');
            pictures[i].removeAttribute('data-srcset');
            pictures[i].removeAttribute('data-sizes');
        }
        
    }
    this.images = images;
}
buddhaSrcset.prototype.windowResize = function(){
    srcset.width = window.innerWidth;
    srcset.setImages();
}

buddhaSrcset.prototype.setImages = function(){
    var t = this;
    var pictures = document.querySelectorAll('figure img');
    for(var i = 0; i < pictures.length; i++) {
        if(typeof t.images[i] != 'undefined'){
            if(t.width > 1200 ){
                 var k =  Object.keys(t.images[i]);
                 pictures[i].src = t.images[i][k[k.length-1]];
                 pictures[i].setAttribute('data-src' , t.images[i][k[k.length-1]]);
            }
            else if(t.width < 1200 && t.width >= 1024){
                 pictures[i].src = t.images[i]["1024w"];
                 pictures[i].setAttribute('data-src' , t.images[i]["1024w"]);
            }
            else if(t.width < 1024 && t.width >= 768){
                 pictures[i].src = t.images[i]["768w"];
                 pictures[i].setAttribute('data-src' , t.images[i]["768w"]);
            }
            else{
                pictures[i].src = t.images[i]["425w"];
                pictures[i].setAttribute('data-src' , t.images[i]["425w"]);
            }
        }
    }
    
}

if ( wp.is_token_page != null && ! wp.is_token_page ) {
    var srcset = new buddhaSrcset();
}
            
